import { createMarkup } from '@utils';

export const Field = (props) => {
  const { wrapperStyle, interpolated, element } = props;

  return (
    <div style={wrapperStyle}>
      <div className="form-item" dangerouslySetInnerHTML={createMarkup(interpolated)}></div>
      {element}
    </div>
  );
};
